module.exports = __webpack_public_path__ + "static/media/background.e60c3728.png";